import {Component, EventEmitter, inject, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {AsyncPipe} from "@angular/common";
import {
    DxButtonComponent,
    DxPopupComponent,
    DxValidationGroupComponent,
    DxTextBoxComponent,
    DxTagBoxComponent,
    DxHtmlEditorComponent,
    DxValidatorComponent
} from "devextreme-angular";
import {
    DxiValidationRuleComponent,
    DxiItemComponent
} from "devextreme-angular/ui/nested";
import {
    AuthService,
    DataSources,
    ScreenService,
    PermissionType,
    AccessType,
    EmailsClient,
    EmailTemplateDto,
    UpdateEmailTemplateCommand,
    RecipientOptionDto,
} from "@services";
import notify from "devextreme/ui/notify";
import {DxiPopupToolbarItemComponent} from "devextreme-angular/ui/popup";
import {
    DxiHtmlEditorItemComponent,
    DxoHtmlEditorMediaResizingComponent,
    DxoHtmlEditorToolbarComponent
} from "devextreme-angular/ui/html-editor";

@Component({
    selector: 'app-email-template-popup',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxPopupComponent,
        DxValidationGroupComponent,
        DxiPopupToolbarItemComponent,
        AsyncPipe,
        DxTextBoxComponent,
        DxTagBoxComponent,
        DxHtmlEditorComponent,
        DxValidatorComponent,
        DxiValidationRuleComponent,
        DxiHtmlEditorItemComponent,
        DxoHtmlEditorMediaResizingComponent,
        DxoHtmlEditorToolbarComponent
    ],
    templateUrl: './email-template-popup.component.html'
})
export class EmailTemplatePopupComponent implements OnInit {
    protected dataSources = inject(DataSources);
    protected screen = inject(ScreenService);
    protected emailsClient = inject(EmailsClient);
    protected auth = inject(AuthService);

    @Input() request: EmailTemplateDto;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onUpdate = new EventEmitter<void>();

    @ViewChild('validationGroup', {static: true}) validationGroup: DxValidationGroupComponent;

    formData: EmailTemplateDto | null = null;
    recipientOptions: string[] = [];

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes['visible'] && changes['visible'].currentValue) {
            await this.loadData();
        }
    }

    ngOnInit(): void {
        this.dataSources.recipientOptions().load().then((data) => {
            this.recipientOptions = (data as RecipientOptionDto[]).map(i => i.value);
        });
    }

    onClose() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.formData = null;
        this.validationGroup?.instance.reset();
    }

    handleSuccess() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.onUpdate.emit();
    }

    handleError(errors: any) {
        errors.forEach(((errMsg: any) => {
            notify({
                message: errMsg.message,
                type: "error",
                displayTime: 5000,
            }, {
                position: "bottom right",
                direction: "up-push"
            });
        }));
    }

    async onSave() {
        const result = this.validationGroup.instance.validate();
        if (!result.isValid)
            return;

        let command = new UpdateEmailTemplateCommand({
            type: this.formData.type,
            subject: this.formData.subject,
            body: this.formData.body,
            description: this.formData.description,
            to: this.formData.to,
            cc: this.formData.cc
        });

        this.emailsClient.updateEmailTemplate(command).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    async loadData() {
        if (this.request) {
            this.emailsClient.getEmailTemplate(this.request.type).subscribe({
                next: (data) => {
                    this.formData = data;
                },
                error: (errors) => this.handleError(errors)
            });
        }
    }

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
